import React, { useEffect, useState } from "react";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import { useFetchData } from "../../../../hooks/useFetchData";
import { published } from "../../../../utils/mainTabs/social/published";
import { useOutletContext } from "react-router";
import { getPublishedByMeActionHandler } from "../../../../store/actions/actionHandlers/manageActionHandler";

const Published = () => {
  const pageSize = 8;
  const { tenantName } = useOutletContext();
  const [tableColumns, setTableColumns] = useState([]);
  const { searchPlaceHolder, columns } = published;
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(getPublishedByMeActionHandler, pageSize);

  useEffect(() => {
    let newTableColumns = columns(tenantName);
    setTableColumns(newTableColumns);
  }, [columns, tenantName]);

  return (
    <DataTable
      columns={tableColumns}
      defaultData={data}
      setDefaultData={setData}
      data={updatedData}
      setData={setUpdatedData}
      totalRows={totalRows}
      loading={loading}
      uniqueFieldName={"ID"}
      fetchMoreData={handleCurrentPage}
      searchable
      setSearchQuery={handleSearchQuery}
      placeholder={searchPlaceHolder}
    />
  );
};

export default Published;
